export default __webpack_public_path__ + "static/logo-desperados-9664749858de15497bd8a67a5a461504.svg";